import { Avatar, Box, Stack, Typography } from "@mui/joy";
import UploadButton from "@rpldy/upload-button";
import UploadDropZone from "@rpldy/upload-drop-zone";
import { useBatchAddListener, useBatchCancelledListener, useBatchFinishListener, useUploady } from "@rpldy/uploady";
import { getAccessToken } from "api";
import FileUploadRoundedIcon from '@mui/icons-material/FileUploadRounded';
import { useCallback, useState } from "react";

export function FeaturedPhotoPicker({ url, scope, showPending = false }) {
    const uploady = useUploady();
    const [pendingUploadCount, setPendingUploadCount] = useState(0);

    useBatchAddListener((batch, options) => {
        let newCount;
        if(options.clearPendingOnAdd) {
            newCount = batch.items.length;
        } else {
            newCount = pendingUploadCount+1;
        }

        setPendingUploadCount(newCount);
    });

    const reduceCount = () => {
        let newCount = pendingUploadCount-1;
        setPendingUploadCount(Math.max(0, newCount));
    }

    useBatchCancelledListener((batch, options) => {
        reduceCount();
    });

    useBatchFinishListener((batch, options) => {
        reduceCount();
    });

    const fileFilter = useCallback((file) => {
        const validMimes = [
            'image/jpeg',
            'image/png',
            'image/gif',
            // 'image/bmp',
        ];

        return validMimes.indexOf(file.type) !== -1;
        //filter out files larger than 5MB
        return file.type === 'jpg';
    }, []);

    const uploadHeaders = {
        Authorization: `Bearer ${getAccessToken()}`,
        'X-Upload-Scope': scope ?? 'default',
    };

    const showPicker = () => {
        uploady.showFileUpload({
            destination: {headers: uploadHeaders},
            fileFilter: fileFilter,
        });
    }

    return (
    <Box sx={{
        '.drag-over': {
            opacity: 0.7
        }
    }}>
        <UploadDropZone
            onDragOverClassName="drag-over"
            grouped
            maxGroupSize={1}
            destination={{headers: uploadHeaders}}
            fileFilter={fileFilter}
        >
            <Stack
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                spacing={2}
                // p={1.5}
                // pt={0}
                sx={{
                    // aspectRatio: 1,
                    position: 'relative',
                    cursor: 'pointer',
                    '&:hover': {
                        '.normal-icon': {
                            // opacity: 0,
                        },
                        '.hover-icon': {
                            opacity: 1,
                        },
                        //
                    },
                }}
                onClick={showPicker}
            >
                <Avatar
                    size="lg"
                    sx={{
                        '--Avatar-size': '5rem',
                        backgroundColor: '#fff',
                        'img': {
                            objectFit: 'contain',
                        },
                    }}
                    src={url}
                >
                    <FileUploadRoundedIcon/>
                </Avatar>
                <Typography
                    fontSize={'sm'}
                >
                    Press here to upload {showPending && pendingUploadCount > 0 && <>({pendingUploadCount} pending)</>}
                </Typography>
                {/*
                <UploadButton destination={{headers: uploadHeaders}}>
                    Upload Photo
                </UploadButton>
                */}
            </Stack>
        </UploadDropZone>
    </Box>
    )
}
